import Model from "../Model";
import tw from "tailwind-styled-components";
import { Label, SideCancelBtn, SubmitBtn } from "../Styles/InputStyles";
import Config from "../../Config";
import { useState, useEffect } from "react";

const RejectModal = ({
    setIsReqRej,
    selectedData,
    reqRejLoading,
    reqRejMutate,
    onboardingReqRejLoading,
    onboardingReqRejMutate,
    refundReqRejLoading,
    refundReqRejMutate,
    refundReqLoading,
    refundReqMutate,
    guestReqLoading,
    guestReqMutate
}) => {

    const [rejectionReason, setRejectionReason] = useState("");
    const [characterCount, setCharacterCount] = useState(0);
    const [error, setError] = useState("");

    useEffect(() => {
        if (selectedData) {
            setRejectionReason("");
            setCharacterCount(0);
            setError("");
        }
    }, [selectedData]);

    const handleReasonChange = (e) => {
        const value = e.target.value;
        if (value.length <= 120) {
            setRejectionReason(value);
            setCharacterCount(value.length);
            setError("");
        }
    };

    const handleRejectSubmit = () => {
        if (!rejectionReason.trim()) {
            setError("Rejection reason is required");
            return;
        }

        if (rejectionReason.trim().length < 10) {
            setError("Rejection reason must be at least 10 characters");
            return;
        }

        if (selectedData?.type === Config.REQUEST_TYPE.ONBOARDING) {
            onboardingReqRejMutate({
                requestId: selectedData?.id,
                reason: rejectionReason.trim()
            });
        } else if (selectedData?.type === Config.REQUEST_TYPE.MOVEOUT) {
            reqRejMutate({
                requestId: selectedData?.id,
                reason: rejectionReason.trim()
            });
        } else if (selectedData?.type === Config.REQUEST_TYPE.GUEST) {
            guestReqMutate({
                requestId: selectedData?.id,
                status: Config.REQUEST_STATUS.REJECTED,
                reason: rejectionReason.trim()
            });
        }
        else {
            refundReqMutate({
                requestId: selectedData?.id,
                status: Config.REQUEST_STATUS.REJECTED,
                reason: rejectionReason.trim()
            });
        }
    };

    const isLoading =
        selectedData?.type === Config.REQUEST_TYPE.ONBOARDING
            ? onboardingReqRejLoading
            : selectedData?.type === Config.REQUEST_TYPE.MOVEOUT
                ? reqRejLoading
                : selectedData?.type === Config.REQUEST_TYPE.GUEST
                    ? guestReqLoading
                    : refundReqLoading;

    return (
        <Model
            width="w-full max-w-md"
            setOpenModel={setIsReqRej}
            title="Confirm Reject Request"
        >
            <WarningText>
                Are you sure you want to reject this request? Please provide a reason for rejection.
            </WarningText>

            <div className=" space-y-1">
                <Label htmlFor="rejectionReason">Reason *</Label>
                <TextArea
                    id="rejectionReason"
                    value={rejectionReason}
                    onChange={handleReasonChange}
                    placeholder="Please provide a detailed reason for rejecting this request (min. 10 characters)"
                    rows="3"
                    className={error ? "border-red-500" : ""}
                />
                <div className="flex justify-between">
                    <div>
                        {error && <ErrorText>{error}</ErrorText>}
                    </div>
                    <CharacterCount>
                        {characterCount}/120
                    </CharacterCount>
                </div>
                <HelpText>
                    * Minimum 10 characters required. This reason will be shared with the requester.
                </HelpText>
            </div>

            <div className="w-full flex justify-between space-x-6 my-4">
                <SideCancelBtn
                    type="button"
                    onClick={() => setIsReqRej(false)}
                    disabled={isLoading}
                >
                    Cancel
                </SideCancelBtn>

                <SubmitBtn
                    onClick={handleRejectSubmit}
                    disabled={isLoading || !rejectionReason.trim() || rejectionReason.trim().length < 10}
                    className={`border  ${isLoading || !rejectionReason.trim() || rejectionReason.trim().length < 10
                        ? "bg-gray-50 text-gray-500 cursor-not-allowed border-gray-500"
                        : "bg-white text-red-500 hover:bg-red-500 hover:text-white border-red-500"}`}
                >
                    {isLoading ? "Processing..." : "Reject Request"}
                </SubmitBtn>
            </div>
        </Model>
    );
};

const WarningText = tw.p`text-gray-500 text-base mb-2`;
const TextArea = tw.textarea`w-full px-3 py-2 border border-gray-300 rounded-lg resize-none`;
const ErrorText = tw.span`text-red-500 text-sm`;
const CharacterCount = tw.span`text-gray-500 text-sm`;
const HelpText = tw.p`text-gray-500 text-xs mt-1`;

export default RejectModal;